import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import { RadioGroup, RadioButton } from 'react-toolbox/lib/radio';
import Button from 'components/CustomButton';
import SearchCollegeComponent from 'components/CoachRegistration';
import Error from 'components/ErrorMessage';
import styles from './Modify.scss';

// to import local scss fle

class ModifyCollege extends Component {
  static propTypes = {
    modifyCollege: PropTypes.func.isRequired,
    collegeModified: PropTypes.bool.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      minGpaErrorMessage: '',
      questionaireLinkErrorMessage: '',
      teamPageErrorMessage: '',
      minActErrorMessage: '',
      twitterErrorMessage: '',
      collegeNewId: '',
      modifyAnotherCollege: false,
      showButton: false,
    };
  }


  getDataForCoach = (value) => {
    const newState = {
      city: value.city,
      division: value.division,
      questionLink: value.questionLink,
      state: value.state,
      teamPageUrl: value.teamPageUrl,
      college: value.value,
      collegeId: value.id,
      minAct: value.minAct,
      minGpa: value.minGpa,
      hbcu: value.hbcu || 'no',
      twitter: value.collegetwitter,
    };
    this.setState(newState);
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value, showButton: true });
  };

  removeValue = (name) => {
    this.setState({ ...this.state, [name]: '' });
  };

  modifyAnotherCollege = () => {
    this.setState({
      modifyAnotherCollege: true,
      division: '',
      city: '',
      state: '',
      questionLink: '',
      teamPageUrl: '',
      college: undefined,
      collegeId: '',
      hbcu: 'no',
      minGpa: '',
      minAct: '',
      twitter: '',
    });
  };

  handleDivisionChange = (hbcu) => {
    this.setState({ hbcu, showButton: true });
  };

  handleOnclick = () => {
    const updated = {};
    const { minGpa, minAct, hbcu, teamPageUrl, questionLink, collegeId,
       twitter, collegeNewId } = this.state;
    // valudation for gpa
    let validGpa = false;
    if (minGpa !== '' && minGpa <= 4) {
      validGpa = true;
    } else {
      updated.minGpaErrorMessage = 'Please add a valid gpa.';
    }
    // validation for act
    let validAct = false;
    if (minAct !== '' && minAct <= 36) {
      validAct = true;
    } else {
      updated.minActErrorMessage = 'Please add a valid act.';
    }
    // validation for twitter
    let validTwitter = true;
    if (twitter && twitter.trim()[0] !== '@') {
      validTwitter = false;
      updated.twitterErrorMessage = 'Please enter valid twitter account';
    }

    // if (twitter !== '') updated.twitterErrorMessage = 'Please enter valid twitter account';

    if (validAct && validGpa && validTwitter) {
      const payload = {
        college_id: collegeId,
        min_act: parseInt(minAct), // eslint-disable-line
        min_gpa: parseFloat(minGpa, 10), // eslint-disable-line
        hbcu,
        football_questionaire_page: questionLink,
        football_team_page: teamPageUrl,
        twitter,
      };
      this.props.modifyCollege(payload);
      if (collegeId === collegeNewId) {
        updated.modifyAnotherCollege = false;
      }
    }
    updated.collegeNewId = collegeId;
    this.setState(updated);
  };

  render() {
    const { modifyAnotherCollege, minGpa, minAct, questionLink, teamPageUrl,
    minGpaErrorMessage, questionaireLinkErrorMessage, teamPageErrorMessage,
      minActErrorMessage, college, city, state, division, hbcu, twitter,
    showButton, twitterErrorMessage } = this.state;
    const { collegeModified } = this.props;
    let form = true;
    if (collegeModified) {
      form = false;
    }
    if (collegeModified && modifyAnotherCollege) {
      form = true;
    }
    const renderForm = renderIf(form);
    const renderCollegeDetails = renderIf(college !== undefined);
    const renderSuccessMessage = renderIf(collegeModified && !modifyAnotherCollege);
    const renderShowButton = renderIf(showButton);

    return (
      <div className={cn('col s12', styles.removePadding)}>
        {renderForm(
          <div className={cn('col s12 m7', styles.addMargin)}>
            <div className={('col s12', styles.halfWidthWithSpan)}>
              <span>SELECT COLLEGE</span>
              <SearchCollegeComponent usedFor="contact" getDataForCoach={this.getDataForCoach} />
            </div>
            {renderCollegeDetails(
              <div><br /><br />
                <span className={styles.selectPlan}>COLLEGE DETAILS</span><br /> <br />
                <span className={styles.desc}>College Name:</span>
                <span className={styles.data}>{college}</span> <br />
                <span className={styles.desc}>City:&nbsp;&nbsp;</span>
                <span className={styles.data}>{city}</span> <br />
                <span className={styles.desc}>State:&nbsp;&nbsp;</span>
                <span className={styles.data}>{state}</span> <br />
                <span className={styles.desc}>Division:&nbsp;&nbsp;</span>
                <span className={styles.data}>{division}</span> <br /><br />
                <div>
                  <span className={styles.selectPlan}>Editable details</span><br />
                  <div className={minGpaErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
                    <span>MINIMUM GPA</span>
                    <Input
                      value={minGpa}
                      onChange={val => this.handleChange('minGpa', val)}
                      onFocus={() => this.removeValue('minGpaErrorMessage')}
                    />
                    <Error message={minGpaErrorMessage} />
                  </div>
                  <div className={minActErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
                    <span>MINIMUM ACT</span>
                    <Input
                      value={minAct}
                      onChange={val => this.handleChange('minAct', val)}
                      onFocus={() => this.removeValue('minActErrorMessage')}
                    />
                    <Error message={minActErrorMessage} />
                  </div>
                  <div className={teamPageErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
                    <span>FOOTBALL TEAMPAGE LINK</span>
                    <Input
                      value={teamPageUrl}
                      onChange={val => this.handleChange('teamPageUrl', val)}
                      onFocus={() => this.removeValue('teamPageErrorMessage')}
                    />
                    <Error message={teamPageErrorMessage} />
                  </div>
                  <div className={questionaireLinkErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
                    <span>QUESTIONNAIRE LINK</span>
                    <Input
                      value={questionLink}
                      onChange={val => this.handleChange('questionLink', val)}
                      onFocus={() => this.removeValue('questionaireLinkErrorMessage')}
                    />
                    <Error message={questionaireLinkErrorMessage} />
                  </div>
                  <div className={twitterErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
                    <span>TWITTER LINK</span>
                    <Input
                      value={twitter}
                      onChange={val => this.handleChange('twitter', val)}
                      onFocus={() => this.removeValue('twitterErrorMessage')}
                    />
                    <Error message={twitterErrorMessage} />
                  </div>
                  <div className={cn('col s12 m12', styles.removePadding)}>
                    <span className={styles.hbcuSpan}>HBCU</span>
                    <RadioGroup name="hbcu" value={hbcu} onChange={this.handleDivisionChange}>
                      <RadioButton label="Yes" value="yes" />
                      <RadioButton label="No" value="no" />
                    </RadioGroup>
                  </div>
                </div>
                {renderShowButton(
                  <Button label="MODIFY COLLEGE" onClick={this.handleOnclick} style={styles.buttonContainer} />,
                )}
              </div>,
            )}
          </div>,
        )}
        {renderSuccessMessage(
          <span className={styles.successMessage}>
                 College details are updated. <br /> <br />
            <Button label="MODIFY ANOTHER COLLEGE" onClick={this.modifyAnotherCollege} style={styles.buttonContainer} />
          </span>,
        )}
      </div>
    );
  }
}

export default ModifyCollege;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/CollegeView/components/ModifyCollege/Modify.js